module.exports = __webpack_public_path__ + "static/media/interactive-image.b3a3a939.svg";